import i18next from 'i18next';
import isEmpty from 'lodash/isEmpty';

import { deleteItem } from 'common/api/winds';
import alerts from 'common/modules/alerts';
import { showReponseErrorsAsAlert } from 'common/utils/helpers';
import showToast from 'common/utils/showToast';

import {
    DELETE_ITEM,
    DELETE_ITEM_FAILURE,
    DELETE_ITEM_SUCCESS,
} from '../actionTypes';
import { actions } from '../reducer';

import fetchItems from './fetchItems';

export default (id, filterData) => (dispatch) => {
    dispatch(actions[DELETE_ITEM]());

    deleteItem(id)
        .then(() => {
            dispatch(actions[DELETE_ITEM_SUCCESS]());
            if (!isEmpty(filterData)) dispatch(fetchItems(filterData));
            dispatch(alerts.actions.close());

            showToast({ body: i18next.t('It was successfully removed') });
        })
        .catch((error) => {
            dispatch(
                actions[DELETE_ITEM_FAILURE](error?.response?.data?.errors),
            );
            showReponseErrorsAsAlert(dispatch, error?.response);
        });
};
